const STORAGE_KEY = "tea-shop-2b-local-print-client-id"
const CLIENT_ID_PREFIX = "local-print-client-"

let cachedClientId: string | null = null

function isValidClientId(value: string | null): value is string {
  return typeof value === "string"
    && value.startsWith(CLIENT_ID_PREFIX)
    && value.length <= 128
}

function createClientId() {
  const suffix = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`
  return `${CLIENT_ID_PREFIX}${suffix}`
}

export function getLocalPrintClientId() {
  if (cachedClientId) return cachedClientId

  try {
    const persisted = localStorage.getItem(STORAGE_KEY)
    if (isValidClientId(persisted)) {
      cachedClientId = persisted
      return cachedClientId
    }
  } catch {
    // Storage may be unavailable in privacy mode. The in-memory id still keeps
    // retries stable for the current page lifetime.
  }

  cachedClientId = createClientId()
  try {
    localStorage.setItem(STORAGE_KEY, cachedClientId)
  } catch {
    // Best effort only; do not prevent local printing when storage is unavailable.
  }
  return cachedClientId
}
